import { createSlice } from '@reduxjs/toolkit'

const commonInitialState = {
  toastNotifications: {
    show: false,
    message: '',
    type: '',
  },
  addRowModal: false,
  supplyUploadFileModal: false,
  isManageCertificateDialogOpen: false,
  uploadCertificateModal: false,
  isShareExtractDialogOpen: false,
}

export const commonSlice = createSlice({
  name: 'common',
  initialState: commonInitialState,
  reducers: {
    setToastNotifications: (state, action) => ({
      ...state,
      toastNotifications: action.payload,
    }),
    resetToastNotifications: (state) => ({
      ...state,
      toastNotifications: [],
    }),
    setAddRowModal: (state, action) => ({
      ...state,
      addRowModal: action.payload,
    }),
    setSupplyUploadModal: (state, action) => ({
      ...state,
      supplyUploadFileModal: action.payload,
    }),
    setManageCertificateDialogOpen: (state, action) => ({
      ...state,
      isManageCertificateDialogOpen: action.payload,
    }),
    setUploadCertificateModal: (state, action) => ({
      ...state,
      uploadCertificateModal: action.payload,
    }),
    setShareExtractDialogOpen: (state, action) => ({
      ...state,
      isShareExtractDialogOpen: action.payload,
    }),
  },
})

export const {
  setToastNotifications,
  resetToastNotifications,
  setAddRowModal,
  setSupplyUploadModal,
  setManageCertificateDialogOpen,
  setUploadCertificateModal,
  setShareExtractDialogOpen,
} = commonSlice.actions

export default commonSlice.reducer
